import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArticlesTable from "../../components/articlesTable";
import { getArticlesList } from "./action";

const Articles = () => {
  const { pageNo, limit, searchKey, sortOrder, status , sortBy} = useSelector(
    (state) => state.ArticleReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getArticlesList());
  }, [pageNo, limit, searchKey, sortOrder, status, sortBy]);

  return (
    <div>
      <ArticlesTable />
    </div>
  );
};

export default Articles;
